module.exports = __webpack_public_path__ + "img/phone.e8e5ca4d.png";